import { useBlocker } from '@tanstack/react-router'
import { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { ConfirmDialog } from '@/shared/ui/confirm-dialog'

export function useUnsavedChangesGuard(enabled: boolean) {
  const { t } = useTranslation()
  const bypassUntilRef = useRef(0)
  const blocker = useBlocker({
    shouldBlockFn: () => {
      if (Date.now() < bypassUntilRef.current) {
        return false
      }
      return enabled
    },
    enableBeforeUnload: enabled,
    withResolver: true,
  })
  const openDialog = blocker.status === 'blocked'

  const allowNextNavigation = () => {
    bypassUntilRef.current = Date.now() + 3000
  }

  const dialog = (
    <ConfirmDialog
      open={openDialog}
      title={t('common.unsavedChangesTitle', { defaultValue: 'Unsaved changes' })}
      description={t('common.unsavedChangesDescription', {
        defaultValue: 'You have unsaved changes. Do you want to discard them and leave this page?',
      })}
      confirmLabel={t('common.discardAndLeave', { defaultValue: 'Discard and leave' })}
      cancelLabel={t('common.continueEditing', { defaultValue: 'Continue editing' })}
      variant="destructive"
      onConfirm={() => {
        blocker.proceed?.()
      }}
      onCancel={() => {
        blocker.reset?.()
      }}
    />
  )

  return { dialog, allowNextNavigation }
}
